import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100">
            <i className="ri-smartphone-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            {appData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            {appData.subtitle}
          </p>
          <a
            href="#app"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-download-2-line"></i>
            {appData.linkText}
          </a>
        </div>
      </div>
    </section>
  );
}